import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { OpenLinkById } from '../../common/services/openlinkbyid';

@Component({
  selector: 'app-concept-statements',
  templateUrl: './concept-statements.component.html'
})
export class ConceptStatementsComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private openlink: OpenLinkById) { }

  baseFasbLink;
  header;
  body;
  subHeading1;
  subBody1;
  subLinkText1;
  subLink1;
  subHeading2;
  subBody2;
  subLinkText2;
  subLink2;
  subHeading3;
  archiveLibraryDescription1;
  archiveLibraryDescription2;
  adobeDownloadLink;
  adobeDownloadText;
  statements1: any;
  statements2: any;

  s3baseurl: string;
  ngOnInit(): void {
    
    this.commonDataService.showLoader.next(true);
    this.getconceptstatementslabels();
    this.graphQlService.getS3BucketPath().subscribe(data => {
      this.s3baseurl = data;
    });
  }

  getconceptstatementslabels() {
    this.graphQlService.getConceptStatementsLabels().subscribe(data => {

      let allData = data.content.data;
      
      allData.statements2.forEach(a => {
        a.label1 = a.label1.replace(/\(Superseded\)/g, '<span class="content-superseded">(Superseded)</span>');
      });

      this.baseFasbLink = allData.searchURL;

      this.header = allData.header;
      this.body = allData.body;

      this.subHeading1 = allData.subHeading1;
      this.subBody1 = allData.subBody1;
      this.subLinkText1 = allData.subLink1.linkText;
      this.subLink1 = allData.subLink1.externalLink;

      this.subHeading2 = allData.subHeading2;
      this.subBody2 = allData.subBody2;
      this.subLinkText2 = allData.subLink2.linkText;
      this.subLink2 = allData.subLink2.externalLink;
      
      this.statements1 = allData.statements1;
      this.subHeading3 = allData.subHeading3;
      this.statements2 = allData.statements2;

      this.archiveLibraryDescription1 = allData.archiveLibraryDescription1;
      this.archiveLibraryDescription2 = allData.archiveLibraryDescription2;
      this.adobeDownloadLink = allData.downloadLink.externalLink;
      this.adobeDownloadText = allData.downloadLink.linkText;

      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  openLinkById(event) {
    event.preventDefault();
    this.openlink.openLinkById(event, true);
  }

  onRightClick(event, data?: any) {
    let id = event.target.id;
    if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {
      event.currentTarget.href = '/layoutComponents/getPdf?isSitesBucket=true' + '&fileName=' + id;
    }
  }
}
